import 'reflect-metadata';
import { Container, ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { TranslateConfigService, TranslateService } from './services/translation/translate-service.interface';
import { TranslateServiceImpl } from './services/translation/translate-service';
import { CoreSearchApiService, SearchSettingLanguage, TranslateSpecificField, FetchCompareInit, GetCompareList, GetCompareOverview, GetCompareText, SearchComparePatent, AddComparePatent, GetComparePatentText } from './infrastructure/api-functions/core-search-api/core-search-api-service.interface';
import { CoreSearchApiServiceImpl } from './infrastructure/api-functions/core-search-api/core-search-api-service';
import psHttp, { psHttp$ } from '@patsnap/common-ps-http';
import { PsHttp } from '@patsnap/tahiti-core/common/ps-http';
import { HttpErrorHandlerContribution, HttpErrorHandlerRegistry, HttpErrorHandlerRegistryImpl } from '@patsnap/tahiti-core/common/http-error-handler-contribution';
import { bindContributionProvider } from '@patsnap/tahiti-core/common/contribution-provider';
import { PsHttp$, PsHttpChannel, PsHttpChannelImpl } from '@patsnap/tahiti-core/common/http-channel';
import { patsnapCopilotModule } from '@/services/patsnap-copilot-module';
import { Message } from '@patsnap/tahiti-core/common/message';
import { Toast } from 'patsnap-biz';
import { CookieService } from '@analytics/shared/services/cookie-service';
import { LocationService, LocationServiceImpl } from '@analytics/shared/services/location-service';
import { LanguageService, LanguageServiceImpl } from '@analytics/shared/services/language-service';
import { businessModule } from '@/container-modules/business-module';
import { componentsModule } from '@/container-modules/components-module'
import { baseModule } from '@/container-modules/base-module';
import { I18nService } from '@analytics/shared/services/i18n.interface';
import { getI18nInstance } from '@/locales/i18nInstance';
import router from '@/router';
import { VueRouterService } from '@analytics/shared/services/vue-router-service.interface';

export const container = new Container({
    defaultScope: 'Singleton',
    skipBaseClassChecks: true,
});

const base = new ContainerModule((bind) => {
    bind(HttpErrorHandlerRegistry).to(HttpErrorHandlerRegistryImpl);
    bindContributionProvider(bind, HttpErrorHandlerContribution);
    bind(PsHttp).toConstantValue(psHttp);
    bind(PsHttp$).toConstantValue(psHttp$);
    bind(PsHttpChannel).to(PsHttpChannelImpl);
    bind(Message).toConstantValue(Toast);
    bind(LocationService).to(LocationServiceImpl);
    bind(CookieService).toConstantValue(document.cookie);
    bind(LanguageService).to(LanguageServiceImpl);
    bind(I18nService).toDynamicValue(() => getI18nInstance());
    bind(VueRouterService).toConstantValue(router);
});

container.bind(CoreSearchApiService).to(CoreSearchApiServiceImpl);
container.bind(TranslateSpecificField).to(CoreSearchApiServiceImpl);
container.bind(SearchSettingLanguage).to(CoreSearchApiServiceImpl);
container.bind(FetchCompareInit).to(CoreSearchApiServiceImpl);
container.bind(GetCompareList).to(CoreSearchApiServiceImpl);
container.bind(GetCompareOverview).to(CoreSearchApiServiceImpl);
container.bind(GetCompareText).to(CoreSearchApiServiceImpl);
container.bind(SearchComparePatent).to(CoreSearchApiServiceImpl);
container.bind(AddComparePatent).to(CoreSearchApiServiceImpl);
container.bind(GetComparePatentText).to(CoreSearchApiServiceImpl);
container.bind(TranslateService).to(TranslateServiceImpl);
container.bind(TranslateConfigService).to(TranslateServiceImpl);
container.load(base);
container.load(new ContainerModule(patsnapCopilotModule));
container.load(baseModule);
container.load(businessModule);
container.load(componentsModule);
